/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmployerViewModel } from './EmployerViewModel';
import {
    EmployerViewModelFromJSON,
    EmployerViewModelFromJSONTyped,
    EmployerViewModelToJSON,
} from './EmployerViewModel';
import type { IAPANNUALINCOMEBAND } from './IAPANNUALINCOMEBAND';
import {
    IAPANNUALINCOMEBANDFromJSON,
    IAPANNUALINCOMEBANDFromJSONTyped,
    IAPANNUALINCOMEBANDToJSON,
} from './IAPANNUALINCOMEBAND';
import type { IAPEMPLOYMENTSTATUS } from './IAPEMPLOYMENTSTATUS';
import {
    IAPEMPLOYMENTSTATUSFromJSON,
    IAPEMPLOYMENTSTATUSFromJSONTyped,
    IAPEMPLOYMENTSTATUSToJSON,
} from './IAPEMPLOYMENTSTATUS';
import type { IAPINDUSTRY } from './IAPINDUSTRY';
import {
    IAPINDUSTRYFromJSON,
    IAPINDUSTRYFromJSONTyped,
    IAPINDUSTRYToJSON,
} from './IAPINDUSTRY';
import type { IAPINDUSTRYSECTOR } from './IAPINDUSTRYSECTOR';
import {
    IAPINDUSTRYSECTORFromJSON,
    IAPINDUSTRYSECTORFromJSONTyped,
    IAPINDUSTRYSECTORToJSON,
} from './IAPINDUSTRYSECTOR';
import type { IAPNATUREOFINCOME } from './IAPNATUREOFINCOME';
import {
    IAPNATUREOFINCOMEFromJSON,
    IAPNATUREOFINCOMEFromJSONTyped,
    IAPNATUREOFINCOMEToJSON,
} from './IAPNATUREOFINCOME';
import type { IAPSOURCEOFWEALTH } from './IAPSOURCEOFWEALTH';
import {
    IAPSOURCEOFWEALTHFromJSON,
    IAPSOURCEOFWEALTHFromJSONTyped,
    IAPSOURCEOFWEALTHToJSON,
} from './IAPSOURCEOFWEALTH';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface EmploymentDetailsViewModel
 */
export interface EmploymentDetailsViewModel {
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof EmploymentDetailsViewModel
     */
    incomeAdded?: IAPYESORNO;
    /**
     * 
     * @type {IAPEMPLOYMENTSTATUS}
     * @memberof EmploymentDetailsViewModel
     */
    employmentStatus?: IAPEMPLOYMENTSTATUS;
    /**
     * 
     * @type {IAPANNUALINCOMEBAND}
     * @memberof EmploymentDetailsViewModel
     */
    annualIncomeBand?: IAPANNUALINCOMEBAND;
    /**
     * 
     * @type {Array<IAPNATUREOFINCOME>}
     * @memberof EmploymentDetailsViewModel
     */
    naturesOfIncomes?: Array<IAPNATUREOFINCOME>;
    /**
     * 
     * @type {string}
     * @memberof EmploymentDetailsViewModel
     */
    otherNatureOfIncomeDescription?: string;
    /**
     * 
     * @type {number}
     * @memberof EmploymentDetailsViewModel
     */
    grossMonthlyIncome?: number;
    /**
     * 
     * @type {string}
     * @memberof EmploymentDetailsViewModel
     */
    occupation?: string;
    /**
     * 
     * @type {IAPINDUSTRYSECTOR}
     * @memberof EmploymentDetailsViewModel
     */
    industrySector?: IAPINDUSTRYSECTOR;
    /**
     * 
     * @type {string}
     * @memberof EmploymentDetailsViewModel
     */
    otherIndustrySectorName?: string;
    /**
     * 
     * @type {IAPINDUSTRY}
     * @memberof EmploymentDetailsViewModel
     */
    industry?: IAPINDUSTRY;
    /**
     * 
     * @type {string}
     * @memberof EmploymentDetailsViewModel
     */
    otherIndustryName?: string;
    /**
     * 
     * @type {EmployerViewModel}
     * @memberof EmploymentDetailsViewModel
     */
    employer?: EmployerViewModel;
    /**
     * 
     * @type {Array<IAPSOURCEOFWEALTH>}
     * @memberof EmploymentDetailsViewModel
     */
    sourcesOfWealth?: Array<IAPSOURCEOFWEALTH>;
    /**
     * 
     * @type {string}
     * @memberof EmploymentDetailsViewModel
     */
    otherSourceOfWealthDescription?: string;
}

/**
 * Check if a given object implements the EmploymentDetailsViewModel interface.
 */
export function instanceOfEmploymentDetailsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EmploymentDetailsViewModelFromJSON(json: any): EmploymentDetailsViewModel {
    return EmploymentDetailsViewModelFromJSONTyped(json, false);
}

export function EmploymentDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmploymentDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'incomeAdded': !exists(json, 'IncomeAdded') ? undefined : IAPYESORNOFromJSON(json['IncomeAdded']),
        'employmentStatus': !exists(json, 'EmploymentStatus') ? undefined : IAPEMPLOYMENTSTATUSFromJSON(json['EmploymentStatus']),
        'annualIncomeBand': !exists(json, 'AnnualIncomeBand') ? undefined : IAPANNUALINCOMEBANDFromJSON(json['AnnualIncomeBand']),
        'naturesOfIncomes': !exists(json, 'NaturesOfIncomes') ? undefined : ((json['NaturesOfIncomes'] as Array<any>).map(IAPNATUREOFINCOMEFromJSON)),
        'otherNatureOfIncomeDescription': !exists(json, 'OtherNatureOfIncomeDescription') ? undefined : json['OtherNatureOfIncomeDescription'],
        'grossMonthlyIncome': !exists(json, 'GrossMonthlyIncome') ? undefined : json['GrossMonthlyIncome'],
        'occupation': !exists(json, 'Occupation') ? undefined : json['Occupation'],
        'industrySector': !exists(json, 'IndustrySector') ? undefined : IAPINDUSTRYSECTORFromJSON(json['IndustrySector']),
        'otherIndustrySectorName': !exists(json, 'OtherIndustrySectorName') ? undefined : json['OtherIndustrySectorName'],
        'industry': !exists(json, 'Industry') ? undefined : IAPINDUSTRYFromJSON(json['Industry']),
        'otherIndustryName': !exists(json, 'OtherIndustryName') ? undefined : json['OtherIndustryName'],
        'employer': !exists(json, 'Employer') ? undefined : EmployerViewModelFromJSON(json['Employer']),
        'sourcesOfWealth': !exists(json, 'SourcesOfWealth') ? undefined : ((json['SourcesOfWealth'] as Array<any>).map(IAPSOURCEOFWEALTHFromJSON)),
        'otherSourceOfWealthDescription': !exists(json, 'OtherSourceOfWealthDescription') ? undefined : json['OtherSourceOfWealthDescription'],
    };
}

export function EmploymentDetailsViewModelToJSON(value?: EmploymentDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IncomeAdded': IAPYESORNOToJSON(value.incomeAdded),
        'EmploymentStatus': IAPEMPLOYMENTSTATUSToJSON(value.employmentStatus),
        'AnnualIncomeBand': IAPANNUALINCOMEBANDToJSON(value.annualIncomeBand),
        'NaturesOfIncomes': value.naturesOfIncomes === undefined ? undefined : ((value.naturesOfIncomes as Array<any>).map(IAPNATUREOFINCOMEToJSON)),
        'OtherNatureOfIncomeDescription': value.otherNatureOfIncomeDescription,
        'GrossMonthlyIncome': value.grossMonthlyIncome,
        'Occupation': value.occupation,
        'IndustrySector': IAPINDUSTRYSECTORToJSON(value.industrySector),
        'OtherIndustrySectorName': value.otherIndustrySectorName,
        'Industry': IAPINDUSTRYToJSON(value.industry),
        'OtherIndustryName': value.otherIndustryName,
        'Employer': EmployerViewModelToJSON(value.employer),
        'SourcesOfWealth': value.sourcesOfWealth === undefined ? undefined : ((value.sourcesOfWealth as Array<any>).map(IAPSOURCEOFWEALTHToJSON)),
        'OtherSourceOfWealthDescription': value.otherSourceOfWealthDescription,
    };
}

